import { configureStore } from "@reduxjs/toolkit";
import landlordslice from "./slices/userSlice";
const store = configureStore({
      reducer: {landlordslice}
})

export default store;